import { useEffect } from "react";

const ClickjackingProtection = () => {
  useEffect(() => {
    // Check if the page is being embedded in an iframe
    if (window.top !== window.self) {
      // Hide all content by modifying the body
      document.body.style.display = "none";
    }
  }, []);

  return null; // This component does not render anything visually
};

export default ClickjackingProtection;
